import React from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import { TooltipInfoRow } from 'components/common/bryntumScheduler/components/tooltips/Components/TooltipInfoRow/TooltipInfoRow';
import { TooltipSection } from 'components/common/bryntumScheduler/components/tooltips/Components/TooltipSection/TooltipSection';
import { MilestoneTooltipProps } from 'components/common/bryntumScheduler/components/tooltips/types';

export const MilestoneTooltipData = ({ data }: MilestoneTooltipProps) => {
    const { startDate } = data;
    const { spi, baselineStartDate, percentDone, plannedPercentDone, originalId } = data.eventRecord.originalData;

    return (
        <>
            <TooltipSection subTitle={'Milestone info:'}>
                <TooltipInfoRow label={'Activity ID'} value={originalId} />
                <TooltipInfoRow // milestone has only the date of the milestone.So start & finish dates are the same
                    label={'Finish Date'}
                    value={startDate ? moment.utc(startDate).format(constants.formats.date.default) : undefined}
                />
                <TooltipInfoRow
                    label={'Baseline Finish Date'}
                    value={
                        baselineStartDate
                            ? moment.utc(baselineStartDate).format(constants.formats.date.default)
                            : undefined
                    }
                />
            </TooltipSection>
            <TooltipSection subTitle={'Milestone performance:'} subTitleInfo={'(based on preceding fragnet)'}>
                <TooltipInfoRow label={'SPI'} value={spi?.toString()} />
                <TooltipInfoRow label={'Planned % Complete'} value={plannedPercentDone?.toString()} />
                <TooltipInfoRow label={'Actual % Complete'} value={percentDone?.toString()} />
            </TooltipSection>
        </>
    );
};
